"use client";

import * as React from "react";
import { ArrowRight, Building2, ChevronRight, ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const familyCompanies = [{
  name: "Elbo Room",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/elbo_room_logo_corporate.png",
  url: "#"
}, {
  name: "Beach Radio",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/beach_radio_logo_corporate.png",
  url: "#"
}, {
  name: "Social Club",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/social_club_logo_corporate.png",
  url: "#"
}, {
  name: "Oceanfront Hospitality",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/oceanfront_hospitality_logo.png",
  url: "#"
}, {
  name: "FTL Real Estate Group",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/ftl_real_estate_logo.png",
  url: "#"
}];
const corporateUpdates = [{
  title: "The New Marina Expansion",
  date: "October 12, 2024",
  description: "State-of-the-art docking facility expansion designed to accommodate luxury vessels, featuring integrated smart-dock technology and premium amenities.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/marina_architecture_render.png",
  link: "#"
}, {
  title: "Downtown Social Club",
  date: "September 28, 2024",
  description: "Exclusive members-only venue opening in the heart of Fort Lauderdale. A sophisticated blend of historic architecture and modern luxury.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/social_club_architecture_render.png",
  link: "#"
}, {
  title: "Beachfront Condominiums Phase II",
  date: "September 15, 2024",
  description: "Luxury living with direct ocean access. The second phase introduces panoramic glass facades and sustainable energy systems.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/condo_architecture_render.png",
  link: "#"
}, {
  title: "Historic Pier Renovation",
  date: "August 30, 2024",
  description: "Restoring the iconic landmark to its former glory while upgrading structural integrity to withstand future coastal challenges.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/pier_architecture_render.png",
  link: "#"
}];
export default function CorporateFamilyHub() {
  return <section id="corporate-family-hub" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        
        {}
        <div className="flex flex-col items-center text-center mb-16 space-y-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium tracking-wider uppercase border border-primary/20">
            <Building2 className="w-4 h-4" />
            <span>Owners & Corporate</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-serif tracking-tight text-foreground uppercase">
            Family of Companies
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg">
            The driving force behind Fort Lauderdale's premier entertainment and hospitality experiences.
          </p>
        </div>

        {}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-12 items-center justify-items-center mb-24">
          {familyCompanies.map((company, i) => <Link key={company.name} to={company.url} data-index={i} className="group relative flex items-center justify-center w-full h-24 p-4 rounded-xl border border-transparent hover:border-border/50 hover:bg-card/30 transition-all duration-500">
              <img src={company.logo} alt={`${company.name} logo`} className="max-h-12 w-auto object-contain filter grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" />
            </Link>)}
        </div>

        {}
        <div className="border-t border-border/50 pt-20">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-6">
            <div className="space-y-2">
              <h3 className="text-3xl md:text-4xl font-serif tracking-tight text-foreground uppercase">
                Corporate Updates
              </h3>
              <p className="text-muted-foreground">
                Latest architectural developments and owner projects.
              </p>
            </div>
            <Button variant="outline" className="w-fit group" asChild>
              <Link to="/CorporatePage">
                View All Projects
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
          </div>

          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {corporateUpdates.map((update, i) => <CarouselItem key={update.title} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                  <div className="group flex flex-col h-full bg-card border border-border rounded-xl overflow-hidden hover:border-primary/50 transition-colors duration-300">
                    <div className="relative aspect-[4/3] overflow-hidden bg-muted">
                      <img src={update.image} alt={update.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                      <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </div>
                    <div className="flex flex-col flex-grow p-6">
                      <div className="text-xs font-mono text-primary mb-3 uppercase tracking-wider">
                        {update.date}
                      </div>
                      <h4 className="text-xl font-bold text-foreground mb-3 line-clamp-2">
                        {update.title}
                      </h4>
                      <p className="text-muted-foreground text-sm line-clamp-3 mb-6 flex-grow">
                        {update.description}
                      </p>
                      <Link to={update.link} className="inline-flex items-center text-sm font-medium text-primary hover:text-primary/80 transition-colors mt-auto w-fit">
                        Read Full Brief
                        <ChevronRight className="w-4 h-4 ml-1" />
                      </Link>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            {}
            <div className="flex items-center justify-end gap-4 mt-8">
              <CarouselPrevious className="static translate-y-0 translate-x-0 bg-card border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors" />
              <CarouselNext className="static translate-y-0 translate-x-0 bg-card border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors" />
            </div>
          </Carousel>
        </div>

      </div>
    </section>;
}